import React from "react";
import { useTranslation } from "react-i18next";

import { HvGlobalActions, HvGrid } from "@hitachivantara/uikit-react-core";

import { UserPhoneAttribute } from "lib/api";
import useStyles from "./styles";
import DetailsContent from "./DetailsContent";

interface DetailsProps {
  mode?: "add" | "edit";
  isIntegration: boolean;
  phones?: UserPhoneAttribute[];
}

const Details: React.FC<DetailsProps> = ({
  mode = "add",
  isIntegration,
  phones,
}) => {
  const { t } = useTranslation("userAddEdit");
  const classes = useStyles();

  return (
    <HvGrid xs={12} container className={classes.root}>
      <HvGrid xs={12}>
        <HvGlobalActions title={t("details.title")} variant="section" />
      </HvGrid>
      <DetailsContent
        mode={mode}
        isIntegration={isIntegration}
        phones={phones}
      />
    </HvGrid>
  );
};

export default Details;
